/**
 * Created by neo on 05.03.17.
 */
import React, { Component } from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import * as mobx from 'mobx';
import { translate  } from 'react-i18next';
import FlightOffer from '../../../Store/FlightOffer';
import DatePicker from './DatePicker';
import { Row, Col, Input, Button, FormGroup, Label, Card, CardBody } from 'reactstrap';
import AircraftSelect from './AircraftSelect';
import BookingRequest from '../../../Store/Booking/BookingRequest';
import { FlightOfferAircraft } from '../../../Store/FlightOffer';
import PricePreview from './PricePreview';
import FlightOfferAvailability from '../../../Store/FlightOffer/FlightOfferAvailability';
import TimeRangePicker from './TimeRangePicker';
import moment from 'moment-timezone';
import { Link } from 'react-router';
import Settings from '../../../Store/Settings';
import Markdown from 'react-remarkable';

type Props = {
  flightOffer: FlightOffer,
  booking: BookingRequest,
  onBook: (bookingRequest: BookingRequest) => void,
  fullscreen?: boolean,
};

@observer
export class Booking extends React.Component<Props, void> {
  @observable availability: ?FlightOfferAvailability = null;
  @observable date: any = null;

  static defaultProps: {
    fullscreen: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
    };
  }

  selectPassengerCount(passengerCount: number) {
    this.props.booking.setPassengerCount(passengerCount);
    this.props.booking.applyDiscounts();
  }

  generateOptions() {
    const options = [];
    for (let i = 1; i <= this.props.booking.maxPassengers; i++) {
      options.push(<option key={i} value={i}>{`${i}`}</option>);
    }

    return options;
  }

  componentWillMount() {
    const nextProps = this.props;
    // availabilites will be reloaded after opening the date picker
    // this.handleLoad(nextProps);

  }

  componentWillReceiveProps(nextProps: Props) {
    // availabilites will be reloaded after opening the date picker
    // this.handleLoad(nextProps);
  }

  async handleLoad(nextProps: Props) {
    if (
      nextProps.flightOffer &&
      nextProps.booking &&
      nextProps.booking.aircraft &&
      nextProps.booking.aircraft.aircraft_model
    ) {
      this.loadAvailabilities(
        nextProps.flightOffer,
        nextProps.booking,
        moment()
          .startOf('month')
          .format('YYYY-MM-DD'),
        moment()
          .endOf('month')
          .format('YYYY-MM-DD'),
      );
    }
  }

  handleExclusive = ({ target: { checked } }: any) => {
    this.props.booking.is_exclusive = checked;
    if (this.props.booking.is_exclusive) {
      this.props.booking.applyDiscounts();
    } else {
      this.selectPassengerCount(this.props.booking.maxNonExclusivePassengers);
    }
  };

  onDateChanged = (date: any) => {
    const { booking, flightOffer } = this.props;
    if (date && date.format) {
      booking.start_time = date.format('YYYY-MM-DD');
      this.loadAvailabilities(flightOffer, booking, booking.start_time, booking.start_time, true);
    }
  };

  onAircraftChanged = (aircraft_offer: FlightOfferAircraft) => {
    const { booking } = this.props;

    if (booking.is_exclusive) {
      booking.setPassengerCount(booking.maxPassengers);
    } else if (!aircraft_offer.price_passenger) {
      // no price per 1 seat, only possible to book exclusively
      booking.setPassengerCount(booking.maxPassengers);
    } else if (booking.passengerCount > booking.maxPassengers) {
      // if number of selected passengers is > maxPassengers, but don't want the plane exclusively, rest passenger count to 1
      booking.setPassengerCount(1);
    }

    booking.applyDiscounts();

    if (this.availability && this.availability.target_date) { // if target date is already selected, we need to reload times
      this.loadAvailabilities(this.props.flightOffer, booking, booking.start_time, booking.start_time, true);
    }
  };

  async loadAvailabilities(
    flightOffer: FlightOffer,
    booking: BookingRequest,
    startDate: string,
    endDate: string,
    setTime: boolean = false,
  ) {
    const start = moment(startDate);
    const end = moment(endDate);
    // await this.loadAvailability(
    //   flightOffer,
    //   booking,
    //   start
    //   .subtract(1, 'month')
    //   .startOf('month')
    //   .format('YYYY-MM-DD'),
    //   end
    //   .subtract(1, 'month')
    //   .endOf('month')
    //   .format('YYYY-MM-DD'),
    // );
    this.loadAvailability(
      flightOffer,
      booking,
      start.startOf('month').format('YYYY-MM-DD'),
      end.endOf('month').format('YYYY-MM-DD'),
      setTime,
    );
    // await this.loadAvailability(
    //   flightOffer,
    //   booking,
    //   start
    //   .add(1, 'month')
    //   .startOf('month')
    //   .format('YYYY-MM-DD'),
    //   end
    //   .add(1, 'month')
    //   .endOf('month')
    //   .format('YYYY-MM-DD'),
    // );
  }

  loadAvailability = async (
    flightOffer: FlightOffer,
    booking: BookingRequest,
    startDate?: any,
    endDate?: any,
    setTime?: boolean = false,
  ) => {
    if (flightOffer && flightOffer.id) {
      this.setState({
        isLoading: true,
      });

      let availability = await FlightOfferAvailability.find(
        flightOffer.id,
        booking.aircraft.id,
        setTime && booking.start_time ? moment(booking.start_time).format('YYYY-MM-DD') : null,
        startDate,
        endDate,
      );

      this.setState({
        isLoading: false,
      });

      if (!availability) {
        // unset booking start time
        booking.start_time = null;
        return;
      }

      // if we only got time info, mix it with available dates we already have
      if (!availability.dates || availability.dates.length === 0) {
        if (this.availability) {
          availability.dates = this.availability.dates;
        }
      }

      this.availability = new FlightOfferAvailability(availability);
      if (setTime) {
        if (availability.times.length > 0) {
          booking.start_time = moment(booking.start_time).format(`YYYY-MM-DD ${availability.times[0].start}`);
        } else {
          // unset start time, but keep date
          booking.start_time = moment(booking.start_time).format('YYYY-MM-DD');
        }
      }
    }
  };

  handleBooking = () => {
    if (this.props.onBook) {
      this.props.onBook(this.props.booking);
    }
  };

  handleMonthChanged = (startDate: any, endDate: any) => {
    this.loadAvailabilities(
      this.props.flightOffer,
      this.props.booking,
      startDate.format('YYYY-MM-DD'),
      endDate.format('YYYY-MM-DD'),
    );
  };

  handleTimeRangeChanged = (startTime: any) => {
    if (this.props.booking) {
      this.props.booking.start_time = moment(this.props.booking.start_time).format(`YYYY-MM-DD ${startTime}`);
    }
  };

  render() {
    const { props: { t, booking, fullscreen } } = this;

    return (
      <Row className='booking-panel'>
        <Col>
          <Card>
            <CardBody>
              <Row>
                <Col className='mb-3'>
                  <div className='airplane-picker separator'>
                    <FormGroup className='mb-4'>
                      <h2>{t('Flug Buchen')}</h2>
                      <AircraftSelect booking={booking} onAircraftChanged={this.onAircraftChanged} />
                    </FormGroup>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div
                    className={this.availability && this.availability.times ? 'date-picker' : 'date-picker separator'}>
                    <FormGroup className='mb-4'>
                      <Label>2. {t('Datum')}</Label>
                      <DatePicker
                        availability={this.availability}
                        onDateChanged={this.onDateChanged}
                        onMonthChanged={this.handleMonthChanged}
                        fullscreen={fullscreen}
                      />
                    </FormGroup>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className='mb-3'>
                  {!this.state.isLoading && <TimeRangePicker
                    availability={this.availability}
                    onChanged={this.handleTimeRangeChanged}
                    label={booking.flightOffer.is_transfer ? t('Pick-up / Drop-off time') : t('Departure - Arrival')}
                  />}
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormGroup
                    style={{ display: booking.is_exclusive || !booking.aircraft.price_passenger ? 'none' : 'block' }}>
                    <Label>3. {t('Anzahl Passagiere')}</Label>
                    <Input
                      type='select'
                      bsSize='sm'
                      disabled={Boolean(booking.is_exclusive)}
                      value={booking.passengerCount}
                      onChange={e => this.selectPassengerCount(Number(e.target.value))}
                    >
                      {this.generateOptions()}
                    </Input>
                  </FormGroup>
                  {
                    booking.is_exclusive &&
                    <FormGroup>
                      <Label>3. {t('Max. passengers')}</Label>
                      <Input
                        bsSize='sm'
                        disabled={true}
                        value={booking.maxPassengers}
                      />
                    </FormGroup>
                  }
                </Col>
              </Row>
              <Row>
                <Col className='mb-3'>
                  <FormGroup check>
                    <Label check>
                      <Input
                        type='checkbox'
                        checked={Boolean(booking.is_exclusive)}
                        onChange={this.handleExclusive}
                        disabled={!booking.aircraft.price_passenger}
                      />{' '}
                      {t('Ganzes Flugzeug buchen')}
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
              {booking.is_exclusive || booking.minPassengers > booking.passengerCount &&
                <Row>
                  <Col>
                    <div className='alert alert-danger'>
                      <Markdown>
                        {t('Note: Booking isn’t confirmed unless the flight has {{passengers_min}} booked passengers.', {
                          passengers_min: booking.minPassengers,
                        })}
                      </Markdown>
                    </div>
                  </Col>
                </Row>
              }
              <Row>
                <Col>
                  {booking.actualPrice > 0 &&
                    <PricePreview booking={booking} onChanged={this.handleTimeRangeChanged} />}
                </Col>
              </Row>
              <Row>
                <Col className='d-flex justify-content-center align-items-center'>
                  <Button
                    color='primary'
                    size='lg'
                    block
                    onClick={this.handleBooking}
                    disabled={this.state.isLoading || !booking.validDate}
                  >
                    {t('Buchen')}
                  </Button>
                </Col>
              </Row>
              <br />
              {
                Settings.settings.has('voucher_template_file_id') && Settings.settings.get('voucher_template_file_id') > 0 &&
                <Row>
                  <Col>
                    <div className='d-flex justify-content-center align-items-center'>
                      <Link
                        className='btn btn-secondary btn-lg p-3'
                        to={`/voucher/offer/${booking.flightOffer.id}?aircraft=${booking.aircraft.id}&exclusive=${booking.is_exclusive}&passengers=${booking.passengerCount}`}
                      >
                        {t('Buy as a gift certificate')}
                      </Link>
                    </div>
                  </Col>
                </Row>
              }
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
}

export default translate ()(Booking);



// WEBPACK FOOTER //
// ./src/App/FlightOffer/View/Booking/index.js